import { apiClient, extractApiError } from './api';
import { Claim, ApiResponse } from '@/types';

class ClaimService {
  /**
   * Get all claims for the current user
   */
  /**
   * Get all claims for the current user
   */
  async getClaims(filters?: any): Promise<Claim[]> {
    try {
      // Backend expects filters as query params
      const response = await apiClient.get<ApiResponse<{ claims: Claim[], total: number }>>('/claims', { params: filters });
      return response.data.data?.claims || [];
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Get claim statistics
   */
  /**
   * Get claim statistics
   */
  async getClaimStats(): Promise<{ totalReimbursed: number, trend: number }> {
    try {
      const response = await apiClient.get<ApiResponse<any>>('/claims/stats');
      const stats = response.data.data;
      
      // Calculate trend based on thisMonth vs previous (mocked trend for now as backend returns snapshot)
      // or if backend provides it. The backend provides `thisMonth`. 
      // Let's rely on what we have or defaulting.
      return {
        totalReimbursed: stats?.totalReimbursed || 0,
        trend: stats?.thisMonth?.count || 0 // Using count as proxy for trend number for now
      };
    } catch {
      return { totalReimbursed: 0, trend: 0 };
    }
  }

  /**
   * Get claim details by ID
   */
  async getClaimDetail(id: string): Promise<Claim> {
    try {
      const response = await apiClient.get<ApiResponse<Claim>>(`/claims/${id}`);
      return response.data.data!;
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Create a new claim
   */
  async createClaim(data: FormData): Promise<Claim> {
    try {
      const response = await apiClient.post<ApiResponse<Claim>>(`/claims`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data.data!;
    } catch (error) {
      throw extractApiError(error);
    }
  }

  async submitClaim(id: string): Promise<Claim> {
    try {
      const response = await apiClient.post<ApiResponse<Claim>>(`/claims/${id}/submit`);
      return response.data.data!;
    } catch (error) {
      throw extractApiError(error);
    }
  }
}

export const claimService = new ClaimService();
export default claimService;
